import React from 'react'

export const worldScenarioTourConfig = (t) => ({
    id: 'world-scenario-generation',
    name: t('tour:world_scenario_generation_name'),
    description: t('tour:world_scenario_generation_desc'),
    icon: 'globe',
    steps: [
        {
            target: '[data-tour="expand-icon"]',
            title: t('tour:world_scenario_generation_step_0_title'),
            content: (
                <div>
                    <p>{t('tour:world_scenario_generation_step_0_content')}</p>
                </div>
            ),
            placement: 'right',
            disableNextInitially: true
        },
        {
            target: '[data-tour="worldScenario"]',
            title: t('tour:world_scenario_generation_step_1_title'),
            content: (
                <div>
                    <p>{t('tour:world_scenario_generation_step_1_content_prefix')} <strong>{t('tour:world_scenario_generation_step_1_content_bold')}</strong> {t('tour:world_scenario_generation_step_1_content_suffix')}</p>
                </div>
            ),
            placement: 'right',
            disableNextInitially: true
        },
        {
            target: '[data-tour="page-preview"]',
            title: t('tour:world_scenario_generation_step_2_title'),
            content: (
                <div>
                    <p>{t('tour:world_scenario_generation_step_2_content')}</p>
                </div>
            ),
            placement: 'left',
            disableNextInitially: true
        },
        {
            target: '[data-tour="create-content-button"]',
            title: t('tour:world_scenario_generation_step_3_title'),
            content: (
                <div>
                    <p>{t('tour:world_scenario_generation_step_3_content_prefix')} <strong>{t('tour:world_scenario_generation_step_3_content_bold')}</strong> {t('tour:world_scenario_generation_step_3_content_suffix')}</p>
                </div>
            ),
            placement: 'top',
            disableNextInitially: true
        }
    ]
})
